module.exports = __webpack_public_path__ + "img/libirio.0f530106.jpg";